module.exports = "/assets/65db70305ccff4b879b8de20369f630c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BD.png
// module id = 2355
// module chunks = 0